import type { AppExternalUsers } from 'components/Editor/XanoExternalDatabaseModal/lib/user'

export const verifyXanoApp = (app: AppExternalUsers): boolean => {
  return app?.externalUsers?.enabled && app?.externalUsers?.provider === 'xano'
}
